<template>
  <div class="panel" @click.prevent="onSelect" :class="{opened: opened, selected: isSelected, 'not-selected': !isSelected}">
    <emblem class="click-target" :character="character"></emblem>
  </div>
</template>

<script>
  import Emblem from '@/components/Emblem'

  export default {
    props: [
      'characterId',
      'opened'
    ],
    name: 'panels',
    data () {
      return {}
    },
    computed: {
      character () {
        return this.$store.getters['destiny/profile/getCharacter'](this.characterId)
      },
      isSelected () {
        return this.characterId === this.$store.state.destiny.profile.selectedCharacter
      }
    },
    components: {
      Emblem
    },
    methods: {
      onSelect () {
        this.$emit('selected', this.characterId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .panel {
    flex-grow: 1;
    transition: opacity 0.2s ease-in-out;
  }
  .selected {
  }
  .not-selected {
    transition: opacity 0.2s ease-in-out;
    opacity: 0.2;
    &:hover {
      opacity: 0.8;
    }
  }
  .click-target {
    cursor: pointer
  }
  @media only screen and (max-width:640px) {
    .panel {
      flex-basis: 100%;
    }
    .selected {
      &.opened {
      }
    }
    .not-selected {
      display: none;
      opacity: 0;
      &.opened {
        display: block;

        opacity: 1;

        transition: opacity 0.2s ease-in-out;
        &:hover {
          opacity: .8 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CharacterPanel.vue?39b9f798